import { constants } from "../../../constants";

export default class Resize {
    constructor(gb) {
        Object.assign(this, { gb });
    }

    BP_handler() {
        if (this.gb.utils.isIframe !== true) {
            this.gb.emitters.emit.game.resize();
        } else {
            return
        }
    }

    EZUGI_handler(msg) {
        this.gb.emitters.emit.web.resize(msg);
    }

    DUSO_handler(data) {
        if (data && data.data && data.data.height) {
            this.gb.emitters.emit.web.resize(data.data.height);
        }
    }

    KIRON_handler(data) {
        if (data && data.command && data.height) {
            this.gb.emitters.emit.web.resize(data);
        }
    }

    GDR2_handler(data) {
        //do not send this to avoid issues with large sizes
        // if (data && data.value) {
        //     this.gb.emitters.emit.web.resize(data);
        // }
    }

    BETGAMESTV_handler(data) {
        if (data.data && data.data.height) {
            this.gb.emitters.emit.web.resize({height: data.data.height});
        }
    }

    _default(msg) {
        this.gb.emitters.emit.web.resize(msg.param);
    }

    exposeEvent() {
        let event = {};

        switch (this.gb.gameProviderProtocol) {
            case constants.EZUGI:
                event["height"] = this.EZUGI_handler;
                break;
            case constants.BP:
                event["requestSize"] = this.BP_handler;
                break;
            case constants.DUSO:
                event["RESIZE"] = this._default;
                break;
            case constants.KIRON:
                event["adjustiframe"] = this.KIRON_handler;
                break;
            case constants.GDR2:
                event["game.resize.height"] = this.GDR2_handler;
                break;
            case constants.BETGAMESTV:
                event["new_resize"] = this.BETGAMESTV_handler;
                break;
            default:
                event["resize"] = this._default;
        }

        return event;
    }
}
